import React from 'react'
import OutputAddress from './OutputAddress';
import { makeStyles } from '@material-ui/styles';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    contentSelect:{  
       backgroundColor: theme.palette.background.grey,
       marginLeft: theme.spacing(1.5), 
       marginRight: theme.spacing(1.5), 
       marginTop: theme.spacing(1), 
       borderRadius: "0.5rem",
       
    },

    title:{  
        marginLeft: theme.spacing(1.5), 
        marginRight: theme.spacing(1.5), 
        marginTop: theme.spacing(0.5),
        marginBottom: theme.spacing(0.5),
        textTransform:"uppercase",
     },

}));

const fullAddress = {
    "details": "3-1",
    "place":{
    "address": "Carrer del Roser, 79, 08004 Barcelona, España",
    "latitude": 41.3720139,
    "longitude": 2.1659128,
    },
}; 

export default function SelectAddress(props) {
    const classes = useStyles();
    const {title,icon,fullAddress,onClickEdit, onClickStoreIcon} = props; 


    const handlerOnClick= ()=>{
       // console.debug("onClick,");
        if(onClickStoreIcon)
        onClickStoreIcon()
    }
    
    return (
            
            <div className={classes.contentSelect} >
                {title && 
                <div className={classes.title}>
                <Typography variant="caption" color="textSecondary">
                    {title}
                </Typography>
                </div>
                }

             <OutputAddress
                    fullAddress={fullAddress}
                    onClickEdit={onClickEdit}
                    icon={icon}
                    onClickStore={handlerOnClick}
             />
            </div>
    )

}
